import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionForm_Actors_Flush_Mutation = graphql(`
  mutation MissionForm_Actors_Flush(
    $actorableId: Id!
    $list: ActorListEnum!
    $versionData: VersionDataInput
  ) {
    flushMissionActors(
      actorableId: $actorableId
      list: $list
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useFlushMissionActorsMutation = () =>
  useGraphQLMutation(MissionForm_Actors_Flush_Mutation);
